<template>
  <div class="revenue-page">
    <el-row :gutter="16" class="summary-row">
      <el-col :span="12">
        <el-card shadow="never" class="summary-card">
          <div class="summary-label">总发帖数量</div>
          <div class="summary-value">{{ formatCount(summary.totalPostCount) }}</div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never" class="summary-card">
          <div class="summary-label">总订单收入</div>
          <div class="summary-value summary-money">{{ formatMoney(summary.totalOrderRevenue) }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card style="margin-bottom: 20px" shadow="never">
      <el-form :model="query" inline>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            unlink-panels
            clearable
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 280px"
            @change="handleDateChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="userNickname" label="发帖用户昵称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userMobile" label="电话" width="140"></el-table-column>
        <el-table-column prop="postTitle" label="发帖标题" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="publishedTime" label="发帖时间" width="170"></el-table-column>
        <el-table-column prop="payTime" label="支付时间" width="170"></el-table-column>
        <el-table-column label="支付金额" width="120" align="right">
          <template slot-scope="{ row }">
            <span class="money-cell">{{ formatMoney(row.payAmount) }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.pageNum = val; fetchList() }"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { getRevenueRecords, getRevenueSummary } from '../../api'

export default {
  name: 'RevenueManage',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      summary: {
        totalPostCount: 0,
        totalOrderRevenue: 0
      },
      query: {
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10
      },
      dateRange: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.fetchSummary()
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const params = { ...this.query }
      if (!params.startTime) delete params.startTime
      if (!params.endTime) delete params.endTime
      getRevenueRecords(params).then(res => {
        const data = res.data || {}
        this.list = data.records || []
        this.total = data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    fetchSummary() {
      const params = { ...this.query }
      if (!params.startTime) delete params.startTime
      if (!params.endTime) delete params.endTime
      getRevenueSummary(params).then(res => {
        this.summary = res.data || { totalPostCount: 0, totalOrderRevenue: 0 }
      })
    },
    handleDateChange(val) {
      if (Array.isArray(val) && val.length === 2) {
        this.query.startTime = val[0]
        this.query.endTime = val[1]
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
    search() {
      this.query.pageNum = 1
      this.fetchData()
    },
    reset() {
      this.dateRange = []
      this.query = {
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10
      }
      this.fetchData()
    },
    formatMoney(value) {
      const num = Number(value || 0)
      return `¥${(num / 100).toFixed(2)}`
    },
    formatCount(value) {
      const num = Number(value || 0)
      return Number.isFinite(num) ? num.toLocaleString() : '0'
    }
  }
}
</script>

<style scoped>
.revenue-page {
  min-height: 100%;
}

.summary-row {
  margin-bottom: 20px;
}

.summary-card {
  min-height: 118px;
}

.summary-label {
  color: #909399;
  font-size: 14px;
  margin-bottom: 12px;
}

.summary-value {
  color: #303133;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

.summary-money {
  color: #f56c6c;
}

.money-cell {
  color: #f56c6c;
  font-weight: 700;
}
</style>
